import React, { useEffect, useState } from 'react';
import { InputProp } from '../../utils/tsConfig';

const CheckBox: React.FC<InputProp> = (props) => {
	const { keyId, setState, state, isArray, indexVal, arrayName, returnKey, width, fieldName, className, options = [], max, min, disabled = false, required = false, onChange } = props;

	const [selected, setSelected] = useState<string[]>([]);

	const getValue = (): string[] => {
		if (isArray && arrayName && indexVal !== undefined && returnKey) {
			return state?.[arrayName]?.[indexVal]?.[returnKey] || [];
		} else if (returnKey) {
			return state?.[returnKey] || [];
		} else {
			return state || [];
		}
	};

	const updateValue = (val: string[]) => {
		if (isArray && arrayName && indexVal !== undefined && returnKey && setState) {
			const updatedState = { ...state };
			if (!updatedState[arrayName]) updatedState[arrayName] = [];
			while (updatedState[arrayName].length <= indexVal) {
				updatedState[arrayName].push({});
			}
			updatedState[arrayName][indexVal][returnKey] = val;
			setState(updatedState);
		} else {
			onChange?.({ value: val });
			if (returnKey && setState) {
				setState({ ...state, [returnKey]: val });
			}
		}
	};

	const toggleOption = (optionValue: string) => {
		let updated: string[];
		if (selected.includes(optionValue)) {
			updated = selected.filter((val) => val !== optionValue);
		} else {
			updated = [...selected, optionValue];
		}
		setSelected(updated);
		updateValue(updated);
	};

	useEffect(() => {
		const val = getValue();
		setSelected(val);
	}, [state]);

	return (
  <div key={keyId} className={`customInput ${className || ''} w-full`} style={{ width }}>
    {fieldName && (
      <h3 className="text-sm font-medium text-gray-800 dark:text-gray-100 mb-2">
        {fieldName.replace(/\*$/, '')}
        {(required || fieldName.endsWith('*')) && <span className="text-red-500 ml-1">*</span>}
      </h3>
    )}

    <div className="flex flex-col gap-2">
      {options.map((opt: any, idx: number) => {
        const optionValue = typeof opt === 'string' ? opt : opt?.value || opt?.label || opt?.name || '';
        const optionLabel = typeof opt === 'string' ? opt : opt?.label || opt?.value || opt?.name || '';
        const isChecked = selected.includes(optionValue);

        return (
          <label key={idx} className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={isChecked}
              disabled={disabled}
              maxLength={max}
              minLength={min}
              onChange={() => toggleOption(optionValue)}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-900 dark:text-gray-100">{optionLabel}</span>
          </label>
        );
      })}
    </div>
  </div>
);

};

export default CheckBox;
